import React from 'react'
import Container from '@mui/material/Container';
import { Typography } from '@mui/material';

function Contact() {
    return (
        <Container maxWidth="md" sx={{ py: 3 }}>
            <h3>Address :</h3>
            <Typography>IndoHive infotech service pvt ltd</Typography>
            <Typography>Office No. D-110,SR No-282,Gini Bellina, Porwal Road, Lohogaon,Pune, Pin-411047</Typography>
            <h3>Contact Number :</h3>
            <Typography>+91-9146568195</Typography>
        </Container>
    )
}

export default Contact